import avatarModule from '../avatarModule';
/*
    Controls the body colors tab of the avatar page, as well as the advanced body colors mode
    Receives updates about bodyColors through the avatarDetailsLoaded event
*/
function bodyColorsController(
  $scope,
  $log,
  avatarService,
  avatarConstantService,
  googleAnalyticsEventsService,
  $rootScope,
  $uibModal,
  avatarUrlConstants
) {
  'ngInject';

  $scope.myBodyColors = {
    headColorId: 0,
    torsoColorId: 0,
    rightArmColorId: 0,
    leftArmColorId: 0,
    rightLegColorId: 0,
    leftLegColorId: 0
  };

  $scope.currentColorId = null;

  $scope.bodyParts = [
    { label: avatarConstantService.bodyParts.all, name: 'all' },
    { label: avatarConstantService.bodyParts.head, name: 'headColorId' },
    { label: avatarConstantService.bodyParts.torso, name: 'torsoColorId' },
    { label: avatarConstantService.bodyParts.leftArm, name: 'leftArmColorId' },
    { label: avatarConstantService.bodyParts.rightArm, name: 'rightArmColorId' },
    { label: avatarConstantService.bodyParts.leftLeg, name: 'leftLegColorId' },
    { label: avatarConstantService.bodyParts.rightLeg, name: 'rightLegColorId' }
  ];

  const allBodyParts = $scope.bodyParts[0];

  let bodyColorsChanged = false;

  $scope.colorsPalette = [];
  $scope.advancedPalette = [];

  function setBodyPartColor(bodyPart, bodyColor) {
    const { brickColorId } = bodyColor;
    const bodyColors = $scope.myBodyColors;
    switch (bodyPart.name) {
      case 'all':
        bodyColors.headColorId = brickColorId;
        bodyColors.torsoColorId = brickColorId;
        bodyColors.leftArmColorId = brickColorId;
        bodyColors.rightArmColorId = brickColorId;
        bodyColors.leftLegColorId = brickColorId;
        bodyColors.rightLegColorId = brickColorId;
        break;
      case 'headColorId':
        bodyColors.headColorId = brickColorId;
        break;
      case 'torsoColorId':
        bodyColors.torsoColorId = brickColorId;
        break;
      case 'leftArmColorId':
        bodyColors.leftArmColorId = brickColorId;
        break;
      case 'rightArmColorId':
        bodyColors.rightArmColorId = brickColorId;
        break;
      case 'leftLegColorId':
        bodyColors.leftLegColorId = brickColorId;
        break;
      case 'rightLegColorId':
        bodyColors.rightLegColorId = brickColorId;
        break;
    }
    updateCurrentColorId();
  }

  function updateCurrentColorId() {
    $scope.currentColorId = areAllColorsTheSame($scope.myBodyColors)
      ? $scope.myBodyColors.headColorId
      : null;
  }

  function areAllColorsTheSame(bodyColors) {
    const c = bodyColors.headColorId;
    return (
      bodyColors.headColorId === c &&
      bodyColors.torsoColorId === c &&
      bodyColors.rightArmColorId === c &&
      bodyColors.leftArmColorId === c &&
      bodyColors.rightLegColorId === c &&
      bodyColors.leftLegColorId === c
    );
  }

  function isWearingColorOnBodyPart(colorId, bodyPart) {
    if (bodyPart.name === 'all') {
      return $scope.currentColorId === colorId;
    }
    return $scope.myBodyColors[bodyPart.name] === colorId;
  }

  function persistBodyColors() {
    return avatarService.setBodyColors($scope.myBodyColors).then(
      function success() {
        $rootScope.$broadcast(avatarConstantService.events.bodyColorsChanged, $scope.myBodyColors);
        $scope.refreshThumbnail();
      },
      function error() {
        $scope.systemFeedback.error(avatarConstantService.bodyColors.failedToUpdate);
      }
    );
  }

  function onAdvancedModalClose() {
    let label = avatarConstantService.googleAnalytics.closeLabel;
    if (bodyColorsChanged) {
      label = avatarConstantService.googleAnalytics.saveLabel;
    }
    googleAnalyticsEventsService.fireEvent(
      avatarConstantService.googleAnalytics.category,
      avatarConstantService.googleAnalytics.advancedBodyColorsAction,
      label
    );
  }

  $scope.isColorSelected = function(bodyColor) {
    return bodyColor.brickColorId === $scope.currentColorId;
  };

  $scope.onColorDotClicked = function(bodyColor, bodyPart) {
    if (typeof bodyPart === 'undefined') {
      bodyPart = allBodyParts;
    }
    setBodyPartColor(bodyPart, bodyColor);
    bodyColorsChanged = true;
    return persistBodyColors();
  };

  $scope.openAdvancedBodyColors = function() {
    $log.debug('advanced body colors');
    bodyColorsChanged = false;
    const modalUrl = avatarUrlConstants.modals.advancedBodyColor.templateUrl;
    var modalData = {
      colorsPalette: $scope.advancedPalette,
      bodyParts: $scope.bodyParts,
      selectedBodyPart: allBodyParts,
      onColorDotClicked: $scope.onColorDotClicked,
      isColorSelected(bodyColor) {
        return isWearingColorOnBodyPart(bodyColor.brickColorId, modalData.selectedBodyPart);
      }
    };
    const modalParams = {
      animation: false,
      templateUrl: modalUrl,
      controller: avatarUrlConstants.modals.advancedBodyColor.controllerName,
      openedClass: avatarUrlConstants.modals.openedClass,
      resolve: {
        modalData
      }
    };
    $uibModal.open(modalParams).result.then(
      function() {
        onAdvancedModalClose();
      },
      function() {
        onAdvancedModalClose();
      }
    );

    googleAnalyticsEventsService.fireEvent(
      avatarConstantService.googleAnalytics.category,
      avatarConstantService.googleAnalytics.advancedBodyColorsAction,
      avatarConstantService.googleAnalytics.openLabel
    );
  };

  $scope.$on(avatarConstantService.events.avatarRulesLoaded, function(event, avatarRules) {
    $scope.colorsPalette = avatarRules.basicBodyColorsPalette;
    $scope.advancedPalette = avatarRules.bodyColorsPalette;
  });

  $scope.$on(avatarConstantService.events.avatarDetailsLoaded, function(event, avatarDetails) {
    $scope.myBodyColors = avatarDetails.bodyColors;
    updateCurrentColorId();
  });
}

avatarModule.controller('bodyColorsController', bodyColorsController);

export default bodyColorsController;
